import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { PerformanceGauge } from "../charts/PerformanceGauge";
import OverallHeader from "../texts/OverallHeader";
import { OverallCard } from "./OverallCard";

const useOverallPerformanceCardStyles = makeThemedStyles(
  "OverallPerformanceCard",
  (theme) => ({
    divider: {
      height: "70px",
    },
  })
);

export const OverallPerformanceCard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      periodName: string;
      disableAnimation?: boolean;
      key: keyof ICardElementWithChildren;
      titleKey: keyof ICardElementWithChildren;
      title?: string;
    }>
  ) => {
    const styles = useOverallPerformanceCardStyles();
    const { element: el } = props;
    return (
      <OverallCard>
        <OverallHeader
          title={props.title || "Overall Performance"}
          periodName={el.period?.name || ""}
        />
        <div className={styles.divider} />
        <div className="chart">
          <PerformanceGauge
            angleStart={-90}
            disableAnimation={props.disableAnimation}
            angleEnd={90}
            width={350}
            height={170}
            element={el!}
            valueKey={props.key}
            prettyKey={props.titleKey}
          />
        </div>
      </OverallCard>
    );
  }
);

export default OverallPerformanceCard;
